<template>
  <div class="connexion-page">
    <section class="form-container">
      <h1>Connexion</h1>
      <form @submit.prevent="handleConnexion">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            type="email"
            id="email"
            v-model="email"
            placeholder="Entrez votre email"
            required
          />
        </div>

        <div class="form-group">
          <label for="password">Mot de passe</label>
          <input
            type="password"
            id="password"
            v-model="password"
            placeholder="Entrez votre mot de passe"
            required
          />
        </div>

        <button type="submit" class="btn-connexion" :disabled="loading">
          {{ loading ? 'Connexion en cours...' : 'Se connecter' }}
        </button>

        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </form>

      <div class="additional-links">
        <router-link to="/forgot-password" class="forgot-password-link">Mot de passe oublié ?</router-link>
        <p>Vous n'avez pas de compte ?
          <router-link to="/inscription" class="btn-inscription">Créer un compte</router-link>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ConnexionPage",
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      errorMessage: "",
    };
  },
  methods: {
    async handleConnexion() {
      if (!this.email || !this.password) {
        this.errorMessage = "Veuillez remplir tous les champs.";
        return;
      }

      this.loading = true;
      this.errorMessage = "";

      try {
        const res = await fetch("http://localhost:2028/loginn/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: this.email.trim(),
            password: this.password,
          }),
        });

        // Peut être vide en cas d'erreur serveur → on protège le JSON.parse
        let data = {};
        try {
          data = await res.json();
        } catch {
          data = {};
        }

        if (!res.ok) {
          this.errorMessage = data.message || "Erreur lors de la connexion.";
          return;
        }

        // Normalisation: l'API peut renvoyer userc ou user
        const user = data.userc || data.user || null;

        // Marquer la session comme connectée (en sessionStorage)
        sessionStorage.setItem("isAuthenticated", "true");
        if (data.token) sessionStorage.setItem("token", data.token);
        if (user) sessionStorage.setItem("user", JSON.stringify(user));

                
            // Redirection selon le rôle de l'utilisateur
        const redirect = sessionStorage.getItem("redirectAfterLogin");

        if (user && user.role === "admin") {
          //Si c’est un administrateur → redirection vers le tableau de bord admin
          this.$router.push("/dashboardAdmin");
          
        } else if (redirect) {
          //Si l’utilisateur venait du panier avant login
          sessionStorage.removeItem("redirectAfterLogin");
          this.$router.push(redirect);
        } else {
          //Sinon → redirection normale vers le compte client
          this.$router.push("/account");
        }

        // Après connexion réussie :
        window.dispatchEvent(new Event("user-updated"));


      } catch (e) {
        console.error(e);
        this.errorMessage = "Erreur lors de la connexion. Veuillez réessayer.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* ====== PAGE DE CONNEXION ====== */
.connexion-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #e0f7f5, #ffffff);
  font-family: "Poppins", "Segoe UI", sans-serif;
  padding: 20px;
}

/* ====== CONTENEUR ====== */
.form-container {
  background: #fff;
  padding: 2.5rem 2rem;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  transition: all 0.3s ease;
}

.form-container:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
}

/* ====== TITRE ====== */
h1 {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #00998B;
  font-size: 1.8rem;
  letter-spacing: 0.5px;
}

/* ====== CHAMPS ====== */
.form-group {
  margin-bottom: 1.2rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
  font-size: 0.95rem;
}

input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

input:focus {
  outline: none;
  border-color: #00998B;
  box-shadow: 0 0 0 3px rgba(0, 153, 139, 0.2);
}

/* ====== BOUTON ====== */
.btn-connexion {
  width: 100%;
  padding: 0.85rem;
  background-color: #00998B;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.btn-connexion:hover:not(:disabled) {
  background-color: #007c71;
  transform: translateY(-2px);
}

.btn-connexion:disabled {
  background-color: #b8d8d5;
  cursor: not-allowed;
}

/* ====== MESSAGES ET LIENS ====== */
.error-message {
  color: #e53935;
  text-align: center;
  margin-top: 1rem;
  font-weight: 500;
}

.additional-links {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 0.9rem;
}

.forgot-password-link,
.btn-inscription {
  color: #00998B;
  text-decoration: none;
  font-weight: 500;
}

.forgot-password-link:hover,
.btn-inscription:hover {
  text-decoration: underline;
}

/* ====== RESPONSIVE ====== */
@media (max-width: 480px) {
  .form-container {
    padding: 1.8rem 1.2rem;
  }
  h1 {
    font-size: 1.5rem;
  }
}

/* ====== 🌙 MODE SOMBRE ====== */
@media (prefers-color-scheme: dark) {
  .connexion-page {
    background: linear-gradient(135deg, #0e1a1a, #1c2626);
  }

  .form-container {
    background: #182224;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.5);
  }

  h1 {
    color: #00c8b1;
  }

  label {
    color: #e6edf1;
  }

  input {
    background: #10191a;
    border: 1px solid #2e3a3a;
    color: #e6edf1;
  }

  input:focus {
    border-color: #00bfa5;
    box-shadow: 0 0 0 3px rgba(0, 191, 165, 0.3);
  }

  .btn-connexion {
    background-color: #00bfa5;
  }

  .btn-connexion:hover:not(:disabled) {
    background-color: #00e6c1;
  }

  .error-message {
    color: #ff6b6b;
  }

  .forgot-password-link,
  .btn-inscription {
    color: #00e6c1;
  }
}
</style>

